import { GetAddressBookUploadErrors } from '../analytics-context-types';
import { getPODModalTag, getPODProductTag } from './utils';

export const getAddressBookUploadErrorsTag = (options: GetAddressBookUploadErrors) => {
  const { product } = getPODProductTag(
    options.productName,
    options.productID,
    options.productType,
    options.productQuantity,
  );

  const addressBookUploadErrorsEvent = [
    {
      eventInfo: {
        eventName: 'address book upload',
        eventAction: 'error',
      },
    },
  ];

  const { modal, user } = getPODModalTag(
    'Address the Envelope - Recipient',
    addressBookUploadErrorsEvent,
    options.projectID,
  );

  const newModal = {
    ...modal,
    messages: options.statusMessages.map((message) => ({ statusMessages: message })),
  };

  return {
    modal: newModal,
    product,
    user,
  };
};
